import { useInitData } from '../../../hooks'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewPortfolioRow } from '../BirdviewPortfolioRow'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

import { getBirdviewPropertyRequestsPathname } from './BirdviewPropertiesWidget.utils'

function BirdviewPropertiesWidget({
  Icon,
  dragHandleProps,
  getRowPathname = getBirdviewPropertyRequestsPathname,
  info,
  section,
  showAllTarget,
  title,
  onNavigate,
}) {
  const { availableSections } = useInitData()
  const { getListTarget, getRowListTarget } = useBirdviewListTarget()

  function handleShowAll(event) {
    onNavigate({ event, link: getListTarget(showAllTarget) })
  }

  function handleOpen({ event, item }) {
    onNavigate({
      event,
      link: getRowPathname({
        availableSections,
        getRowListTarget,
        id: item.id,
      }),
    })
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      info={info}
      isRefreshing={section.isRefreshing}
      skeletonProps={{ hasAction: false, hasSubtitle: false }}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewPortfolioRow
          Icon={Icon}
          item={item}
          key={item.id}
          onOpen={handleOpen}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewPropertiesWidget
